import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";


import "../styles/contactus.css"
import Axios from '../utils/axiosInstance';

const ContactUs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [captchaToken, setCaptchaToken] = useState(null);

  useEffect(()=>{
    scrollToTop();
  })
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCaptchaChange = (token) => {
    setCaptchaToken(token);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!captchaToken) {
      toast.error("Please complete the captcha verification.");
      return;
    }
    const frmDt = new FormData();
    frmDt.append("name", formData.name)
    frmDt.append("email", formData.email)
    frmDt.append("phone_number", formData.phone)
    frmDt.append("message", formData.message)

    
    try {
      
      await Axios.post(`${process.env.REACT_APP_API_BASE_URL}policies/contactUs/`, frmDt, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success("We have received your query, will get back to you in a while.")
    } catch (error) {
      // Silently catch the error without showing it
    } finally {
      setCaptchaToken(null); // Reset captcha
      // Always dispatch logout and navigate to login page
      navigate("/");
    }
  };

  return (
    <div className="container mx-auto px-6 py-12 flex gap-12">
      {/* Contact Form */}
      <div className="flex-1 bg-white p-8 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">Contact Us</h2>
        <form onSubmit={handleSubmit}>
          {/* Full Name */}
          <div className="mb-4">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="mt-2 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Email Address */}
          <div className="mb-4">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="mt-2 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Phone Number */}
          <div className="mb-4">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              className="mt-2 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          {/* Message */}
          <div className="mb-4">
            <label htmlFor="message" className="block text-sm font-medium text-gray-700">Your Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleInputChange}
              className="mt-2 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="6"
              required
            ></textarea>
          </div>

          {process.env.REACT_APP_RECAPTCHA_ENABLER === "true" ? (
          <div className="mb-4">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={handleCaptchaChange}
            />
          </div>
          ):null}
          <button
            type="submit"
            className="w-full py-2 text-white bg-black rounded-xl hover:bg-gray-900 transition "
          >
            Submit
          </button>
        </form>
      </div>

      {/* Contact Info */}
      <div className="flex-1 p-8 rounded-lg shadow-md bg-no-repeat bg-cover contactUsContainerRight">
        <h3 className="text-xl font-semibold text-white mb-4 ">Our Office</h3>
        <p className="text-white mb-2">
          <strong className="text-white">Address:</strong> <span className='text-xs'> 123 Main Street, City, Country </span>
        </p>
        <p className="text-white mb-2">
          <strong className="text-white">Phone:</strong><span className='text-xs'> +1 234 567 890 </span>
        </p>
        <p className="text-white">
          <strong className="text-white">Email:</strong> <span className='text-xs'>contact@sapphireonline.pk</span> 
        </p>
      </div>
    </div>
  );
};

export default ContactUs;
